import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="bg-white max-w-3xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6">
        {t("terms.title")}
      </h1>

      <section className="prose prose-gray max-w-none">
        <h2 className="text-xl font-semibold mt-8">{t("terms.acceptance.title")}</h2>
        <p>{t("terms.acceptance.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.eligibility.title")}</h2>
        <p>{t("terms.eligibility.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.account.title")}</h2>
        <p>{t("terms.account.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.products.title")}</h2>
        <p>{t("terms.products.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.pricing.title")}</h2>
        <p>{t("terms.pricing.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.orders.title")}</h2>
        <p>{t("terms.orders.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.payment.title")}</h2>
        <p>{t("terms.payment.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.shipping.title")}</h2>
        <p>{t("terms.shipping.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.returns.title")}</h2>
        <p>{t("terms.returns.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.intellectualProperty.title")}</h2>
        <p>{t("terms.intellectualProperty.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.conduct.title")}</h2>
        <p>{t("terms.conduct.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.disclaimer.title")}</h2>
        <p>{t("terms.disclaimer.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.liability.title")}</h2>
        <p>{t("terms.liability.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.changes.title")}</h2>
        <p>{t("terms.changes.text")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("terms.contact.title")}</h2>
        <p>
          {t("terms.contact.text")}{" "}
          <a
            href="mailto:hola@mexabeer.com"
            className="text-indigo-600 hover:text-indigo-800 font-medium"
          >
            hola@mexabeer.com
          </a>
        </p>

        <div className="mt-12">
          <Link
            to="/"
            className="inline-flex items-center rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-orange-700"
          >
            {t("terms.backHome")}
          </Link>
        </div>
      </section>
    </div>
  );
}